import n26Logo from '@assets/images/logo-112x112.png'
import type { PressReleasePageVariationEntries } from '@cms/data/getPressReleaseArticle'

export const getStructuredDataForPressReleaseArticle = (
  article: PressReleasePageVariationEntries,
  url: string,
  websiteUrl: string
) => {
  const { title, date, excerpt, publishedAt, ogImage } = article

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    headline: title,
    datePublished: date,
    dateModified: publishedAt,
    publisher: {
      '@type': 'Organization',
      name: 'N26',
      logo: {
        '@type': 'ImageObject',
        url: `${websiteUrl}${n26Logo}`,
      },
    },
    author: {
      '@type': 'Organization',
      name: 'N26',
    },
    description: excerpt,
    image: [ogImage?.url],
  }

  return structuredData
}
